<script>
    import Title from "./title.svelte";
    import ImageCompare from "svelte-image-compare"

    const numOfFrames = 4;
    const frameIntArray = Array.from(new Array(numOfFrames), (x,i) => i + 1);

</script>

<style>
    .compare-grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-gap: 2rem;
        padding-top: 10px;
    }

    #wrapper {
        /* margin-top: 1.5em; */
        /* margin-bottom: 1.5em; */
        /* border: 1px solid var(--gray-border); */
        /* border-radius: var(--border-radius); */
        /* padding-top: 0em; */
        grid-column: page;
        max-width: calc(100vw - 2em);
    }

</style>

<figure id="training-comparison">
    <div id="wrapper" class="interactive-container">
        <Title
        titleText="Comparison of Fourier Features vs Raw Position"
        subtitleText="Fourier Features allow for high frequency functions in low domains."
    />
        <div class="compare-grid">
        {#each frameIntArray as frameInt, i}
            <div class="box">
                <ImageCompare
                    before="images/training/iteration_{frameInt * 250}.jpg" 
                    after="images/training/iteration_no_posenc_{frameInt * 250}.jpg" 
                    overlay={false}
                >
                    <span slot="before">PosEnc</span>
                    <span slot="after">Raw</span>
                </ImageCompare>
                Iteration {frameInt * 250}
            </div>
        {/each}
    </div>
    </div>
    <figcaption style="grid-column: text;"><a class="figure-number" href="#training-comparison">4</a>: Comparison of Raw Data input vs positional encoding through various iterations (250, 500, 750, 1000).</figcaption>
</figure>